<div class="modal-header" [ngClass]="{'account-linking-header': isAccountLinking}">
  <div *ngIf="isAccountLinking" class="account-linking-logo">
    <img src="assets/flavorAssets/external-images/sita-logo.png" alt="Logo" class="logo-image" />
  </div>
  <h4 class="modal-title" *ngIf="!isAccountLinking">{{ dialogMessage.header }}</h4>
</div>
<div class="modal-body" [ngClass]="{'account-linking-body': isAccountLinking}">
  <p *ngIf="isAccountLinking" class="one-last-step">{{ "DIALOG_MESSAGES.ONE_LAST_STEP" | translate }}</p>

  <div *ngIf="isAccountLinking && !linkPassword" class="provider-icons">
    <div class="provider-icon google-icon">
      <svg viewBox="0 0 48 48" width="48" height="48">
        <path fill="#EA4335" d="M24 9.5c3.54 0 6.71 1.22 9.21 3.6l6.85-6.85C35.9 2.38 30.47 0 24 0 14.62 0 6.51 5.38 2.56 13.22l7.98 6.19C12.43 13.72 17.74 9.5 24 9.5z"></path>
        <path fill="#4285F4" d="M46.98 24.55c0-1.57-.15-3.09-.38-4.55H24v9.02h12.94c-.58 2.96-2.26 5.48-4.78 7.18l7.73 6c4.51-4.18 7.09-10.36 7.09-17.65z"></path>
        <path fill="#FBBC05" d="M10.53 28.59c-.48-1.45-.76-2.99-.76-4.59s.27-3.14.76-4.59l-7.98-6.19C.92 16.46 0 20.12 0 24c0 3.88.92 7.54 2.56 10.78l7.97-6.19z"></path>
        <path fill="#34A853" d="M24 48c6.48 0 11.93-2.13 15.89-5.81l-7.73-6c-2.15 1.45-4.92 2.3-8.16 2.3-6.26 0-11.57-4.22-13.47-9.91l-7.98 6.19C6.51 42.62 14.62 48 24 48z"></path>
        <path fill="none" d="M0 0h48v48H0z"></path>
      </svg>
    </div>
    <span class="link-arrows">↔</span>
    <div class="provider-icon microsoft-icon">
      <svg viewBox="0 0 48 48" width="48" height="48">
        <path fill="#ff5722" d="M6 6h18v18H6z"></path>
        <path fill="#4caf50" d="M26 6h18v18H26z"></path>
        <path fill="#ffc107" d="M6 26h18v18H6z"></path>
        <path fill="#03a9f4" d="M26 26h18v18H26z"></path>
      </svg>
    </div>
  </div>
  <p *ngIf="!cancelRequestButton && !declineButton && !resetPassword && !linkPassword"
     [ngClass]="{'account-linking-message': isAccountLinking}">
    {{ dialogMessage.body }}
  </p>
  <div *ngIf="isAccountLinking && linkPassword" class="provider-icons password-icon-section">
    <div class="provider-icon microsoft-icon">
      <svg viewBox="0 0 48 48" width="48" height="48">
        <path fill="#ff5722" d="M6 6h18v18H6z"></path>
        <path fill="#4caf50" d="M26 6h18v18H26z"></path>
        <path fill="#ffc107" d="M6 26h18v18H6z"></path>
        <path fill="#03a9f4" d="M26 26h18v18H26z"></path>
      </svg>
    </div>
  </div>

  <p *ngIf="linkPassword" style="margin-bottom: 15px;" class="account-linking-message">
    {{ dialogMessage.body }}
  </p>
  <label
    *ngIf="cancelRequestButton || declineButton || resetPassword || linkPassword"
    for="reason"
    class="labelStyle"
    >{{
      (resetPassword ? "DIALOG_MESSAGES.EMAIL" : linkPassword ? "DIALOG_MESSAGES.PASSWORD_LABEL" : "DIALOG_MESSAGES.REASON")
        | translate
    }}</label
  >
  <textarea
    *ngIf="cancelRequestButton || declineButton"
    [(ngModel)]="reasonText"
    #reason
    type="text"
    class="form-control"
    id="reason"
    placeholder="{{ 'DIALOG_MESSAGES.REASON_GOES_HERE' | translate }}"
    (keyup)="checkReason($event)"
    rows="4"
  ></textarea>

  <input
    *ngIf="resetPassword"
    [(ngModel)]="email"
    #reset
    type="text"
    class="form-control"
    id="reset"
    placeholder="{{ 'DIALOG_MESSAGES.ENTER_EMAIL' | translate }}"
    (keyup)="onCheckEmail($event)"
  />
  <div
    *ngIf="resetPassword && (!email || email == '') && inputTouched"
    class="text text-danger"
  >
    {{ "FORMS.EMAIL" | translate }}
    {{ "FORMS.VALIDATION_MESSAGE" | translate }}
  </div>
  <div
    class="text text-danger"
    style="margin: 0px !important"
    *ngIf="resetPassword && !isValidEmail && email != '' && inputTouched"
  >
    {{ "FORMS.INVALID_EMAIL_ADDRESS" | translate }}
  </div>

  <input
    *ngIf="linkPassword"
    [(ngModel)]="password"
    #passwordInput
    type="password"
    class="form-control"
    id="passwordInput"
    placeholder="{{ 'DIALOG_MESSAGES.ENTER_PASSWORD' | translate }}"
    (keyup)="onCheckPassword($event)"
  />
  <div
    *ngIf="linkPassword && (!password || password == '') && inputTouched"
    class="text text-danger"
  >
    {{ "FORMS.PASSWORD" | translate }}
    {{ "FORMS.VALIDATION_MESSAGE" | translate }}
  </div>
</div>

<div class="modal-footer" [ngClass]="{'account-linking-footer': isAccountLinking}">
  <!--Action Buttons-->
  <div *ngFor="let item of dialogMessage.viewButtons" class="button-wrapper">
    <button
      *ngIf="item !== 'linkPassword'"
      class="btn mr-1"
      [disabled]="
        item == 'cancelRequest' || item == 'decline'
          ? !isReasonValid
          : resetPassword && item == 'reset'
          ? !isValidEmail || !email
          : linkPassword && item == 'link'
          ? !isValidPassword || !password
          : false
      "
      (click)="onPassBack(item)"
      type="button"
      [ngClass]="{
        'btn-primary': item == 'ok' || item == 'reset' || item === 'link',
        'account-linking-primary-btn': isAccountLinking && item === 'link',
        'account-linking-cancel-btn': isAccountLinking && item === 'cancel',
        widthButton: item == 'ok',
        'btn-danger':
          item == 'cancelRequest' ||
          item == 'discard' ||
          item == 'delete' ||
          item == 'decline',
        'btn-success':
          item == 'approve' || item == 'recover' || item === 'print',
        'btn-light': item == 'cancel' && !isAccountLinking,
        'decline-style': item == 'decline'
      }"
    >
      <span *ngIf="!isAccountLinking || item !== 'cancel'">
        {{
          "DIALOG_MESSAGES." +
            (item == "cancelRequest"
              ? "CANCEL_REQUEST"
              : path == "pending" && item != "cancel" && item != "discard"
              ? item + "_REQUEST"
              : item)
            | uppercase
            | translate
        }}
      </span>
      <span *ngIf="isAccountLinking && item === 'cancel'" class="back-to-login-text">
        <span class="gray-text">{{ "DIALOG_MESSAGES.DIFFERENT_METHOD" | translate }}</span>
        {{ "DIALOG_MESSAGES.BACK_TO_LOGIN" | translate }}
      </span>
    </button>
  </div>
</div>
